export const AccordionItem = ({
	title,
	content,
	index,
	currentSelected,
	setCurrentSelected,
}) => {
	const isOpen = currentSelected === index;

	const handleOnClick = () => {
		if (isOpen) {
			setCurrentSelected(0);
		} else {
			setCurrentSelected(index);
		}
	};

	return (
		<div
			className={`
				bg-white rounded-xl border transition-all duration-300
				${isOpen ? 'border-accent/30 shadow-card' : 'border-surface-200 hover:border-surface-300'}
			`}
		>
			<button
				onClick={handleOnClick}
				className="w-full flex items-center justify-between p-5 md:p-6 text-left"
			>
				<h3 className={`text-body-md md:text-body-lg font-semibold pr-4 transition-colors ${isOpen ? 'text-accent' : 'text-primary'}`}>
					{title}
				</h3>
				<div className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-300 ${isOpen ? 'bg-accent text-white rotate-180' : 'bg-surface-100 text-surface-600'}`}>
					<svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
					</svg>
				</div>
			</button>
			<div
				className={`
					overflow-hidden transition-all duration-300 ease-in-out
					${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}
				`}
			>
				<div className="px-5 md:px-6 pb-5 md:pb-6">
					<div className="pt-2 border-t border-surface-100">
						<p className="text-body-md text-surface-600 pt-4 leading-relaxed">{content}</p>
					</div>
				</div>
			</div>
		</div>
	);
};
